import { HttpTypes } from '@/types';
import { BaseCustomPage } from '@/types/http/custom-pages/common';
import { AxiosInstance, AxiosRequestConfig } from 'axios';

class CustomPages {
  private client: AxiosInstance;
  private routePath = '/sites';

  public host = '';

  constructor(client: AxiosInstance) {
    client.interceptors.request.use();

    this.client = client;
  }

  interceptRequest(config: AxiosRequestConfig) {
    config.headers = {
      ...config.headers,
    };

    return config;
  }

  async detail(
    slug: string,
    headers?: Record<string, unknown>
  ): Promise<HttpTypes.IResponse<BaseCustomPage>> {
    this.interceptRequest({ ...this.client.request });
    const result = await this.client.get(`${this.routePath}/custom-page/${slug}`, {
      headers: {
        ...headers,
        'X-Jstore-Host': this.host,
      },
    });
    return result.data;
  }

  async list(headers?: Record<string, unknown>): Promise<HttpTypes.IResponse<BaseCustomPage[]>> {
    this.interceptRequest({ ...this.client.request });
    const result = await this.client.get(`${this.routePath}/pages/list`, {
      headers: {
        ...headers,
        'X-Jstore-Host': this.host,
      },
    });
    return result.data;
  }
}

export default CustomPages;
